/* eslint-disable @typescript-eslint/member-ordering */
type CreatePageInfoOptions = {
  total?: number;
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  startCursor?: string | null;
  endCursor?: string | null;
};
/* eslint-enable @typescript-eslint/member-ordering */

/**
 * Creates a PageInfo object to use in paginated mock responses.
 *
 * By default, this function returns a page with a single result, and no
 * previous or subsequent pages. You can override this by passing in an options
 * object with the keys you want to differ from the default.
 */
export const createPageInfo = (options?: CreatePageInfoOptions) => {
  /* eslint-disable sort-keys */
  const defaultPageInfo = {
    total: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: null,
    endCursor: null,
  };
  /* eslint-enable sort-keys */
  return { ...defaultPageInfo, ...options };
};
